import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    PurchaseDto,
    Status,
    PaymentStatus,
    TaxType,
    PurchaseType,
    EntityDto,
    PurchaseReturnServiceProxy,
    CommonLookupServiceProxy,
    DropDownLookupDto,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import * as moment from 'moment';

@Component({
    templateUrl: './purchaseReturns.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class PurchaseReturnsComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;


    maxPTaxFilter: number;
    maxPTaxFilterEmpty: number;
    minPTaxFilter: number;
    minPTaxFilterEmpty: number;
    vendorDisplayPropertyFilter = '';
    currencyNameFilter = '';
    paymentTermNameFilter = '';

    status = Status;
    paymentStatus = PaymentStatus;
    taxType = TaxType;
    purchaseType = PurchaseType;

    uploadUrl: string;
    dateRange: Date[] = [];
    dateRangeSelected = false;
    pNo: '';
    referenceNo: '';
    returnStatus = 0;
    vendorId = 0;
    allvendors: DropDownLookupDto[];
    allStatus: DropDownLookupDto[];

    constructor(
        injector: Injector,
        private _purchaseReturnServiceProxy: PurchaseReturnServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _httpClient: HttpClient,
        public utilsService: UtilsService
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/purchaseInvoices/ImportFromExcel';
    }

    ngOnInit(): void {
        this.initializeDateRange();
        this.populateDropDowns();
    }



    initializeDateRange() {
        const today = new Date();
        this.dateRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            new Date(today.getFullYear(), today.getMonth(), today.getDate())
        ];
    }

    OnselectDateRange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.dateRangeSelected = isChecked;
    }

    setDateRange(type: string) {
        const today = new Date();
        let start: Date, end: Date;

        switch (type) {
            case 'today':
                start = end = today;
                break;
            case '7days':
                start = new Date();
                start.setDate(today.getDate() - 6);
                end = today;
                break;
            case '30days':
                start = new Date();
                start.setDate(today.getDate() - 29);
                end = today;
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'lastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            default:
                start = end = today;
        }

        this.dateRange = [start, end];
    }

    populateDropDowns() {
        this._commonLookupServiceProxy.getAllVendorForTableDropdown().subscribe((result) => {
            this.allvendors = result;
            this.vendorId = 0;
        });

        this._commonLookupServiceProxy.getAllPurchaseReturnStatusForTableDropdown().subscribe((result) => {
            this.allStatus = result;
            this.returnStatus = 0;
        });
    }

    getPurchaseReturns(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

        this._purchaseReturnServiceProxy
            .getAll(
                this.returnStatus,
                this.vendorId,
                this.pNo,
                this.referenceNo,
                this.dateRangeSelected,
                startDate ? DateTime.fromISO(startDate) : undefined,
                endDate ? DateTime.fromISO(endDate) : undefined,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createPurchaseReturn(): void {
        this._router.navigate(['/app/purchase/purchaseReturns/createOrEdit']);
    }

    deletepurchaseReturn(purchaseReturn: PurchaseDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._purchaseReturnServiceProxy.delete(purchaseReturn.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }
    convertToDraft(purchaseReturn: PurchaseDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this.primengTableHelper.showLoadingIndicator();
                var entitDto = new EntityDto();
                entitDto.id = purchaseReturn.id;
                this._purchaseReturnServiceProxy.convertPurchaseReturnToDraft(entitDto).subscribe(() => {
                    this.getPurchaseReturns({});
                    this.notify.success(this.l('SuccessfullyDraft'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
    }
    convertToReturned(purchaseReturn: PurchaseDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var entitDto = new EntityDto();
                this.primengTableHelper.showLoadingIndicator();
                entitDto.id = purchaseReturn.id;
                this._purchaseReturnServiceProxy.convertDraftToPurchaseReturn(entitDto).subscribe(() => {
                    this.getPurchaseReturns({});
                    this.notify.success(this.l('SuccessfullyApproved'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
    }

    exportToExcel($event): void {
        //this._purchaseReturnServiceProxy
        //    .getPurchaseReturnsToExcel(
        //        this.filterText,
        //        $event,
        //        this.maxPTaxFilter == null ? this.maxPTaxFilterEmpty : this.maxPTaxFilter,
        //        this.minPTaxFilter == null ? this.minPTaxFilterEmpty : this.minPTaxFilter,
        //        this.vendorDisplayPropertyFilter,
        //        undefined,
        //        this.currencyNameFilter,
        //        undefined,
        //        this.paymentTermNameFilter,
        //        undefined,
        //    )
        //    .subscribe((result) => {
        //        this._fileDownloadService.downloadTempFile(result);
        //    });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportpurchaseInvoicesProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportpurchaseInvoicesUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportpurchaseInvoicesUploadFailed'));
    }

    resetFilters(): void {
        this.pNo = '';
        this.dateRangeSelected = false;
        this.referenceNo = '';
        this.vendorId = 0;
        this.getPurchaseReturns();
    }

    print(id: number): void {
            window.open(AppConsts.remoteServiceBaseUrl + '/Purchase/PurchaseReturn/' + id, '_blank');
    }

    printVoucher(id: number): void {
        window.open(AppConsts.remoteServiceBaseUrl + '/Account/JournalVoucher/' + id, '_blank');
    }

    showExcelColumnSelectionModal() {
        this._purchaseReturnServiceProxy.getPurchaseReturnExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }

  
}
